import Hammer from 'hammerjs'

const dragMixin = {
	data() {
		return {
			endX: 0,
			endY: 0
		}
	},
	mounted() {
		this.operateHammer()
	},
	methods: {
		// 拖拽
		operateHammer() {
			const hammer = new Hammer(this.$refs['board'])
			this.touchDrag(hammer, this)
		},
		touchDrag(hammer, self) {
			let initX = 0
			let initY = 0
			const dragDom = self.$refs['board']
			hammer.get('pan').set({ enable: true, direction: Hammer.DIRECTION_ALL })
			hammer.on('panstart', function(event) {
				dragDom.style.transform = `translate(${self.dragStartX}, ${self.dragStartY}) scale(${self.scaleState}) rotate(${self.rotateDegree}deg)`
				initX = event.center.x
				initY = event.center.y
			})
			hammer.on('panmove', function(event) {
				self.endX = event.center.x - initX + self.dragStartX
				self.endY = event.center.y - initY + self.dragStartY
				if (!self.isContentPage) {
					if (self.endX >= 250) {
						self.endX = 250
					} else if (Math.abs(self.endX) >= document.body.clientWidth - dragDom.offsetWidth + 250) {
						self.endX = dragDom.offsetWidth - document.body.clientWidth - 250
					}
					if (self.endY <= -250) {
						self.endY = -250
					} else if (Math.abs(self.endY) >= document.body.clientHeight - dragDom.offsetHeight + 250) {
						self.endY = document.body.clientHeight - dragDom.offsetHeight + 250
					}
				}
				dragDom.style.transform = `translate(${self.endX + 'px'}, ${self.endY + 'px'}) scale(${self.scaleState}) rotate(${self.rotateDegree}deg)`
			})
			hammer.on('panend', function() {
				self.dragStartX = self.endX
				self.dragStartY = self.endY
				self.endX = 0
				self.endY = 0
			})
		}
	}
}
export default dragMixin
